import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/(static-pages)/termsofservice/page.tsx")